import React from 'react';
import { storyblokEditable, StoryblokComponent } from 'gatsby-source-storyblok';
import Breadcrumb from './breadcrumb';
const Page = ({ blok, breadcrumbs, currentStoryInternalId }) => {
  return (
    <main
      {...storyblokEditable(blok)}
      className="grid grid-cols-12 gap-x-2 md:gap-x-4 max-w-screen-xl mx-auto -pt-[1rem] px-2 md:px-4"
    >
      {blok.show_breadcrumb && (
        <Breadcrumb blok={blok} breadcrumbs={breadcrumbs} />
      )}
      {blok.show_title && (
        <div
          className="col-span-12 px-4 md:px-8 mt-0"
          {...storyblokEditable(blok)}
        >
          <h1 className="text-lg lg:text-2xl">{blok.title}</h1>
        </div>
      )}

      {blok &&
        blok.body &&
        blok.body.map((nestedBlok) => (
          <StoryblokComponent
            blok={nestedBlok}
            key={nestedBlok._uid}
            hotelID={blok.hotel_id}
            currentStoryInternalId={currentStoryInternalId}
          />
        ))}
    </main>
  );
};

export default Page;
